export const locale = {
  lang: 'de',
  data: {
    SELECTED: 'ausgewählt',
    DELETE: 'Sicher alle selektierten Einträge zu löschen?'
  }
};
